<template>
  <v-app class="view">
    <div class="list-header"
         :style="{
                        paddingLeft:(drawer_width+12)+'px',
                        paddingRight:(12)+'px',

                     }">
      <v-row
          class="list-header-row">
        <v-col class="text-right">
          <!--itemHeight{{itemHeight}}-->
          <!--scrollY{{scrollY}}-->

          <!--startElementIndex{{startElementIndex}}-->


          เรียงตาม:
          <a href="#" :class="{active:sort==='short_name'}" @click="changeSort('short_name')">ชื่อ</a> &nbsp;
          <a href="#" :class="{active:sort==='price_retail'}" @click="changeSort('price_retail')">ราคา</a> &nbsp;
          <a href="#" :class="{active:sort==='size'}" @click="changeSort('size')" class="mr-4">ปริมาณ</a>

          <v-icon large :class="{primary:display==='grid'}"
                  @click="changeDisplay('grid')">mdi-view-grid
          </v-icon>
          <v-icon large :class="{primary:display==='column2'}"
                  @click="changeDisplay('column2')">mdi-format-columns
          </v-icon>
          <v-icon large :class="{primary:display==='list'}"
                  @click="changeDisplay('list')">mdi-format-align-justify
          </v-icon>


        </v-col>
      </v-row>
    </div>

    <v-content>

      <v-container
          class="fill-height container"
          fluid
          :style="{
                        paddingLeft:(drawer_width)+'px',
                     }">


        <!--row,top  = floor(index/column)  -->
        <!--col,left  = index%column  -->
        <ProductRow class="pad-filter"
                    :class="'display-'+display"
                    v-for="(product, index) in items"
                    :product="product"
                    :key="index"
                    :display="display"
                    :currentIndex="-padItemOffset+startElementIndex+index-padItemAmount"
                    :style="{
                        left:((drawer_width+6)+((index%column_no)*column_width))+'px',
                        width: column_width+'px',
                        top:(Math.floor((-padItemOffset+startElementIndex+index-padItemAmount)/column_no)*itemHeight)+'px'
                     }"
        >

        </ProductRow>

        <LoadingDummy
            :store="store"
            :itemHeight="itemHeight"
            :scrollY="scrollY"
            :maxElementRender="maxElementRender">
        </LoadingDummy>


        <!--<div v-if="!$store.state.products.data || $store.state.products.data.length===0" v-for="n in 50">-->
        <!--</div>-->
        <!--<v-card-->

        <!--:style="{position:'absolute',top:(Math.max(50,$store.state.products.data.length)*itemHeight)+'px'}"-->
        <!--v-intersect="insssfiniteScrolling"></v-card>-->

        <!--<div v-if="!$store.state.products.response.links || $store.state.products.response.links.next"-->
        <!--v-for="n in 10">-->
        <!--<v-skeleton-loader-->
        <!--ref="skeleton"-->
        <!--type="actions"-->
        <!--:tile="true"-->
        <!--class="mx-auto"-->
        <!--&gt;</v-skeleton-loader>-->
        <!--</div>-->


      </v-container>
    </v-content>
    <v-navigation-drawer
        class="nav"
        permanent
        :width="drawer_width"
        touchless
    >
      <v-card class="pl-2 pt-2 pr-2 pb-2">
        <v-text-field class="search"

                      label="ค้นหา"
                      placeholder="ใส่คำค้นหา"
                      outlined
                      hide-details="true"
                      clearable
                      v-model="filter_search_keyword"
                      @click:clear="clear_reload()"
                      @keydown.enter="reload()"
        ></v-text-field>
      </v-card>

      <v-card class="pa-2" tile outlined :class="{primary:is_promotion}"
              @click="setFilter('promotion')">
        โปรโมชั่น
        <v-icon class="float-right" v-if="is_promotion">mdi-close</v-icon>
      </v-card>

      <FilterCurrent :filter="store.filter" :setFilter="setFilter"></FilterCurrent>
<!--      <v-btn @click="setFilter('item_from','K')">test</v-btn>-->
    </v-navigation-drawer>

  </v-app>
</template>
<style lang="scss" scoped>

a.active {
  font-weight: bold;
}

.view {
  font-size: 18px;
}

.nav {
  z-index: 1;
}

.container {
  position: relative;
  margin-top: 40px;
  min-width: 750px;
}

.pad-filter {
  padding: 16px 0 0 12px;
}

.search .v-input__control {
  /*height: 60px;*/
}

.list-header {
  position: fixed;
  top: 60px;
  z-index: 1;
  width: 100%;

}

.theme--light .list-header-row {
  background: #FFFFFF;
}

.theme--dark .list-header-row {
  background: #000000;
}

.display-grid {

}

.display-column2 {

}

</style>
<script lang="ts">
import {OrderConst} from '@/models/Order'
import {Component} from 'vue-property-decorator'
import FilterCurrent from '../components/FilterCurrent.vue'
import LoadingDummy from '../components/LoadingDummy.vue'
import ProductRow from '../components/Product/ProductRow.vue'
import {Product} from '../models/Product'
import Helper from '../services/Helper.js'
import ListView from './ListView'

@Component({
  components: {FilterCurrent, LoadingDummy, ProductRow}
})
export default class ViewProduct extends ListView<Product> {
  // items: Product[] = []
  store = this.$store.state.products

  drawer_ratio = 0.2

  commit_prefix = 'products'
  base_url = Helper.setting.product.getListAPI


  display = 'column2'

  beforeLoad() {


    if (this.$store.state.carts && this.$store.state.carts.current && this.store.filter['item_from']) {
      const cartItemFrom = this.$store.state.carts.current.item_from
      console.log('*** cartItemFrom', cartItemFrom)
      let filter: string | null = OrderConst.ITEM_FROM_KCCP
      if (cartItemFrom == OrderConst.ITEM_FROM_KCCP) {
        filter = OrderConst.ITEM_FROM_KCCP
      } else if (cartItemFrom == OrderConst.ITEM_FROM_OFM) {
        filter = OrderConst.ITEM_FROM_OFM
      }
      if (this.store.filter['item_from'].current.length == 0 && filter) {
        this.setFilter('item_from', filter)
      } else if (this.store.filter['item_from'].current.length > 0 && !filter) {
        this.clearFilter('item_from')
      } else if (this.store.filter['item_from'].current.length > 0 && filter && this.store.filter['item_from'].current[0].key != filter) {
        this.store.filter['item_from'].current = []
        this.setFilter('item_from', filter)
      }
    }
  }

  get column_no() {
    switch (this.display) {
      case 'list':
        return 1
      case 'column2':
        return 2
      case 'grid':
        return 4
    }
    return 1
  }

  get column_width() {
    return this.display_width / this.column_no
    // switch (this.display) {
    //   case 'list':
    //     return this.display_width/this.column_no;
    //   case 'column2':
    //     return 400
    //   case 'grid':
    //     return 200
    // }
  }
}
</script>
<style lang="scss" scoped>
.view {

  .fill-height {
    padding-left: 150px;
  }
}

.nav {
  position: fixed;
  margin-top: 60px;

}
</style>
